import type { PublicSlotKey } from '#packages/apilib';
import type { ReadonlyModeApi } from './readonlyModeApi';

export const ReadonlyModeApiKey: PublicSlotKey<ReadonlyModeApi> = {
  name: 'ReadonlyModeApi',
  public: true,
};
